import { useState } from 'react';
import { passwordLogin } from '../boot';
import { reportError, useT } from '../i18n';
import { useSession } from '../store/session';
import { DevLogin } from './DevLogin';

/**
 * Outside Telegram: the web portal login with the game id (or @username) and the password set in Services.
 * A development login (DEV_AUTH_ENABLED servers only) is one tap away for local testing.
 */
export function Login() {
  const t = useT();
  const config = useSession((s) => s.config);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [dev, setDev] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await passwordLogin(login.trim(), password);
    } catch (err) {
      reportError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="portal" data-testid="login">
      <div className="portal-page login-page">
        <h1 className="store-title">{config?.brand.name ?? t('app.title')}</h1>
        <form
          className="dark-form portal-card"
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}
        >
          <b>{t('login.title')}</b>
          <input
            className="dark-input"
            autoComplete="username"
            placeholder={t('login.login')}
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            data-testid="login-name"
          />
          <input
            className="dark-input"
            type="password"
            autoComplete="current-password"
            placeholder={t('login.password')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
          />
          <button
            className="portal-btn green"
            type="submit"
            disabled={busy || !login.trim() || !password}
            data-testid="login-submit"
          >
            {t('login.submit')}
          </button>
          <p className="dark-hint">{t('login.hint')}</p>
        </form>
        {config?.botUsername && (
          <a
            className="portal-btn"
            href={`https://t.me/${config.botUsername}`}
            target="_blank"
            rel="noreferrer"
          >
            {t('login.open_bot')}
          </a>
        )}
        <button className="dev-toggle" onClick={() => setDev((d) => !d)} data-testid="dev-toggle">
          {t('login.developer')}
        </button>
      </div>
      {dev && (
        <div className="dev-login-wrap">
          <DevLogin />
        </div>
      )}
    </div>
  );
}
